const UUID_REGEX = /[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/;

export function getPageNameFromUrlPath(urlPath: string) {
  const pageName =
    urlPath
      .split('/')
      .reverse()
      .find((pathElement) => !pathElement.match(UUID_REGEX) && pathElement)
      ?.replace(/-/g, ' ') || '';

  return pageName;
}
